import type { DoorStyle } from 'src/modules/designStudio/helpers/data/TemplateDesignConfig';

export const doorStylesByPaletteName: Record<
  string,
  { doorStyles: DoorStyle[] }
> = {
  Minimalist: {
    doorStyles: [
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.34,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4497,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.4,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4110,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.47,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4515,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.47,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4512,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.573170731707317,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4509,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.573170731707317,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4506,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.6,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4503,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.64,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4518,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.7317073170731707,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4500,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.7804878048780488,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4494,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.9,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4521,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 1.146341463414634,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4615,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 1.7317073170731707,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4617,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 2.3095238095238093,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4273,
        },
      },
    ],
  },
  Elegant: {
    doorStyles: [
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.34,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4173,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.4,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4078,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.47,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4191,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.47,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4188,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.573170731707317,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4185,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.573170731707317,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4182,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.6,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4179,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.64,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4194,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.7317073170731707,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4176,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.7804878048780488,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4170,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.9,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4197,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 1.146341463414634,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4590,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 1.7317073170731707,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4592,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 2.3095238095238093,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4378,
        },
      },
    ],
  },
  Robust: {
    doorStyles: [
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.34,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4200,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.4,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4075,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.47,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4223,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.47,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4220,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.573170731707317,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4217,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.573170731707317,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4214,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.6,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4211,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.64,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4229,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.7317073170731707,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4208,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.7804878048780488,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4205,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.9,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4226,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 1.146341463414634,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4618,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 1.7317073170731707,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4620,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 2.3095238095238093,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4277,
        },
      },
    ],
  },
  Decorated: {
    doorStyles: [
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.34,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4286,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.4,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4084,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.47,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4304,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.47,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4301,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.573170731707317,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4298,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.573170731707317,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4295,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.6,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4292,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.64,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4307,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.7317073170731707,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4289,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.7804878048780488,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4283,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.9,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4310,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 1.146341463414634,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4594,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 1.7317073170731707,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4596,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 2.3095238095238093,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4313,
        },
      },
    ],
  },
  Rustic: {
    doorStyles: [
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.34,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4436,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.4,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4104,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.47,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4455,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.47,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4451,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.573170731707317,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4448,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.573170731707317,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4445,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.6,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4442,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.64,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4458,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.7317073170731707,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4439,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.7804878048780488,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4433,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.9,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4461,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 1.146341463414634,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4623,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 1.7317073170731707,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4625,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 2.3095238095238093,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4279,
        },
      },
    ],
  },
  Striking: {
    doorStyles: [
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.34,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4143,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.4,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4096,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.47,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4161,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.47,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4158,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.573170731707317,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4155,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.573170731707317,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4152,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.6,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4149,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.6464646464646465,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4164,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.7317073170731707,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4146,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.7804878048780488,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4140,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.9,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4167,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 1.146341463414634,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4598,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 1.7317073170731707,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4600,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 2.3095238095238093,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4262,
        },
      },
    ],
  },
  Bold: {
    doorStyles: [
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.34,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4467,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.4,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4107,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.47,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4484,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.47,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4481,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.573170731707317,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4479,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.573170731707317,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4476,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.6,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4473,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.64,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4486,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.7317073170731707,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4470,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.7804878048780488,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4464,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.9,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4491,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 1.146341463414634,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4611,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 1.7317073170731707,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4613,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 2.3095238095238093,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4270,
        },
      },
    ],
  },
  Adventurous: {
    doorStyles: [
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.34,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4234,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.4,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4080,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.47,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4252,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.47,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4249,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.573170731707317,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4246,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.573170731707317,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4243,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.6,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4240,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.64,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4255,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.7317073170731707,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4237,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.7804878048780488,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4231,
        },
      },
      {
        policy: {
          onSide: ['front'],
          onLabels: [102],
          onAspectRatio: {
            ratio: 0.9,
            tol: 0.05,
          },
        },
        appearance: {
          textureId: 4258,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 1.146341463414634,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4603,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 1.7317073170731707,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4605,
        },
      },
      {
        policy: {
          onLabels: [103],
          onAspectRatio: {
            ratio: 2.3095238095238093,
            tol: 0.25,
          },
        },
        appearance: {
          textureId: 4264,
        },
      },
    ],
  },
};
